import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const ARB_APP_CATEGORIES: SupportCategory[] = [
  { id: 'arb-app-error', label: 'Error/ Issues', departmentId: 'App' },
  { id: 'arb-app-question', label: 'Question', departmentId: 'App' },
  { id: 'arb-app-feature', label: 'Feature Requests', departmentId: 'App' },
];

export const ARB_APP_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'arb-app-error-sub', label: 'Error/ Issues', categoryId: 'arb-app-error' },
  { id: 'arb-app-question-sub', label: 'Question', categoryId: 'arb-app-question' },
  { id: 'arb-app-feature-sub', label: 'Feature Requests', categoryId: 'arb-app-feature' },
];

const ERROR_QUESTIONS: SupportSubcategoryQuestion[] = [
  { id: 'arb-app-error-1', subcategoryId: 'arb-app-error-sub', type: 'text', label: 'Subject', required: true },
  {
    id: 'arb-app-error-2',
    subcategoryId: 'arb-app-error-sub',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'arb-app-error-3',
    subcategoryId: 'arb-app-error-sub',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
];

const QUESTION_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'arb-app-question-1',
    subcategoryId: 'arb-app-question-sub',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'arb-app-question-2',
    subcategoryId: 'arb-app-question-sub',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'arb-app-question-3',
    subcategoryId: 'arb-app-question-sub',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
];

const FEATURE_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'arb-app-feature-1',
    subcategoryId: 'arb-app-feature-sub',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'arb-app-feature-2',
    subcategoryId: 'arb-app-feature-sub',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'arb-app-feature-3',
    subcategoryId: 'arb-app-feature-sub',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
];

export const ARB_APP_QUESTIONS: SupportSubcategoryQuestion[] = [
  ...ERROR_QUESTIONS,
  ...QUESTION_QUESTIONS,
  ...FEATURE_QUESTIONS,
];
